<template>
  <section>
    <md-toolbar class="md-transparent md-title" md-elevation="0">
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <md-button class="md-icon-button" @click="closeWindow">
            <md-icon>close</md-icon>
          </md-button>

          <h3 class="md-title">Manage</h3>
        </div>

        <div class="md-toolbar-section-end" @click="closeWindow">
          <md-button class="md-icon-button">
            <md-icon>close</md-icon>
          </md-button>
        </div>
      </div>
    </md-toolbar>

    <md-list v-if="false">
      <md-list-item to="/admin/treatments">
        <md-icon>list</md-icon>
        <span class="md-list-item-text">Treatments </span>
      </md-list-item>
      <md-list-item>
        <md-icon>delete</md-icon>
        <span class="md-list-item-text">Trash</span>
      </md-list-item>
    </md-list>

    <!-- TODO no settings avail for now  -->
    <md-list v-if="false">
      <md-subheader>Calendar</md-subheader>

      <md-list-item>
        <md-icon>event_available</md-icon>
        <span class="md-list-item-text">Enforce Available Time Slots</span>
        <md-switch v-model="settings.timeAvailabillity" />
      </md-list-item>
    </md-list>
    <md-empty-state
      class="md-primary md-small"
      md-icon="build_circle"
      md-label="Under construction"
      md-description="Please come back later."
    >
    </md-empty-state>
  </section>
</template>

<script>
import { eventBus } from "../eventbus";

export default {
  name: "AdminDrawer",
  data: function () {
    return {
      settings: {
        timeAvailabillity: true,
        bluetooth: false,
      },
    };
  },
  methods: {
    closeWindow: function () {
      eventBus.openCloseLeftSidemenu();
    },
  },
  created: async function () {},
};
</script>

<style lang="scss" scoped>
.md-list {
  width: 320px;
  max-width: 100%;
  display: inline-block;
  vertical-align: top;
  border: 1px solid rgba(#000, 0.12);
}
</style>